import backend from '../services/backend';
import { Link } from './Link';
import SortableTable from './SortableTable';
import { formatDateTime } from '../lib/dateFormat';
import { useQuery } from '@tanstack/react-query';

export default function PageDocuments({ pageId }: { pageId: string }) {
  const { data } = useQuery({
    queryKey: ['documents', pageId],
    queryFn: () => backend.listDocumentsByPage(pageId).then((res) => res.data),
  });

  const documents = data?.items ?? [];

  return (
    <div className="mt-8">
      <h2 className="text-lg font-medium text-gray-900 mb-4 dark:text-zinc-100">Documents that contain this page</h2>

      <div className="overflow-hidden rounded-lg">
        <SortableTable
          storageId="page-documents"
          columns={[
            {
              accessor: 'id',
              label: 'Document ID',
              render: (document) => (
                <Link to={`/documents/${document.id}`}>
                  {document.id.slice(0, 10)}...{document.id.slice(-10)}
                </Link>
              ),
            },
            {
              accessor: 'pageIndex',
              label: 'Page Number',
              render: (doc) => doc.pageIndex + 1,
            },
            {
              accessor: 'fileName',
              label: 'File Name',
              render: (document) => document.fileName || <span className="text-gray-400">—</span>,
            },
            {
              accessor: 'createdAt',
              label: 'Created',
              render: (document) =>
                document.createdAt ? formatDateTime(document.createdAt) : <span className="text-gray-400">—</span>,
            },
            {
              accessor: 'status',
              label: 'Status',
              render: (document) => (
                <span
                  className={
                    document.status === 'done'
                      ? 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap bg-green-100 text-green-800'
                      : 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap bg-gray-100 text-gray-800'
                  }
                >
                  {document.status}
                </span>
              ),
            },
          ]}
          data={documents}
          rowKey={(row) => row.id}
        />
      </div>
    </div>
  );
}
